export default "__VITE_ASSET__CJd0ebQS__"